import { useQuery } from '@tanstack/react-query';
import { getPricingRates, calculateCredits, type PricingRatesResponse, type CreditCalculationRequest, type CreditCalculationResponse } from '@/api/pricing';
import { useCallback } from 'react';

export const usePricingRates = () => {
  const {
    data: rates,
    isLoading,
    error,
    refetch
  } = useQuery<PricingRatesResponse>({
    queryKey: ['pricing-rates'],
    queryFn: getPricingRates,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });

  const calculateCreditCost = useCallback(async (
    activityType: 'audio_generation' | 'shorts_generation',
    durationMinutes?: number
  ): Promise<CreditCalculationResponse> => {
    const request: CreditCalculationRequest = {
      activity_type: activityType,
      duration_minutes: durationMinutes
    };
    return await calculateCredits(request);
  }, []);

  return {
    rates,
    isLoading,
    error,
    refetch,
    calculateCreditCost,
    // Convenience accessors
    audioRate: rates?.audio_rate ?? 0,
    shortsRate: rates?.shorts_rate ?? 1,
    userType: rates?.user_type ?? 'individual',
    tier: rates?.tier ?? 'free',
    overageMultiplier: rates?.overage_multiplier ?? 1.0,
  };
};
